import Vue from 'vue';
import Vuex from 'vuex';
import { vuexfireMutations } from 'vuexfire';

Vue.use(Vuex);

import user from './modules/user';
import projects from './modules/projects';
import orders from './modules/orders';
import header from './modules/header';
import invoices from './modules/invoices';
import locations from './modules/locations';

let store = new Vuex.Store({
  state: {
    pendingRoute: '',
  },
  mutations: {
    queueRoute(state, path) {
      state.pendingRoute = path;
    },
    ...vuexfireMutations,
  },
  modules: {
    header,
    projects,
    orders,
    user,
    invoices,
    locations,
  },
});

export default store;
